'use client';
import { config } from '@/configs/configPortal';
import { MODELS_BIKE_MOST_VIEWED, MODELS_CAR_MOST_VIEWED, TEXT_TYPE_VEHICLE } from '@/helpers/constants';
import { isVehicleType } from '@/helpers/utils';
import { formatToSlug } from '@/helpers/slug/slug';
import { useGeneralStore } from '@/providers/general-store-provider';
import Image from 'next/image';
import Link from 'next/link';
import { useMemo } from 'react';
import './model.scss';

export default function Models() {
    const currentUrl = config.urlTableFipe
    const webmotorsUrl = process.env.NEXT_PUBLIC_CATALOG_ASSETS_PATH

    const { vehicleType } = useGeneralStore();

    const isBike = useMemo(() => isVehicleType(vehicleType, 'bike'), [vehicleType]);

    const modelList = useMemo(() => (isBike ? MODELS_BIKE_MOST_VIEWED : MODELS_CAR_MOST_VIEWED), [isBike]);

    function getTypeVehicleText() {
        return isBike ? TEXT_TYPE_VEHICLE.bikes : TEXT_TYPE_VEHICLE.cars
    }

    return (
        <div id="home-models-container" className="home-models-container" data-testid="home-models-container">
            <div id="grid-models" className="grid-models" data-testid="grid-models">
                {modelList?.map((model, index) => (
                    <Link
                        key={`model-link-${String(index)}`}
                        href={`${currentUrl}/${getTypeVehicleText()}/${formatToSlug(model.makeName)}/${model.modelSlug}`}
                        id={`model-link-${String(index)}`}
                        data-testid={`model-link-${String(index)}`}
                    >
                        <div
                            id={`grid-models-container-${String(index)}`}
                            className="grid-models-container"
                            data-testid={`grid-models-container-${String(index)}`}
                        >
                            <div
                                id={`model-image-container-${String(index)}`}
                                className="model-image"
                                data-testid={`model-image-container-${String(index)}`}
                            >
                                <Image
                                    src={
                                        isBike
                                            ? `${process.env.NEXT_PUBLIC_ASSETS_PATH}/assets/img/bike-default.svg`
                                            : model.versionLinkImage
                                                ? `${webmotorsUrl}/imagens/prod${model.versionLinkImage}.webp?s=fill&w=136&h=100&q=70&t=true`
                                                : `${process.env.NEXT_PUBLIC_ASSETS_PATH}/assets/img/car_default.svg`
                                    }
                                    alt={`Marca ${model.makeName}`}
                                    title={`Modelo ${model.modelName}`}
                                    width={136}
                                    height={100}
                                    data-testid={`model-image-${String(index)}`}
                                    loading="lazy"
                                    id={`model-image-${String(index)}`}
                                />
                            </div>
                            <div
                                id={`model-info-${String(index)}`}
                                className="model-info model-title"
                                data-testid={`model-info-${String(index)}`}
                            >
                                {model.makeName} <strong>{model.modelName}</strong>
                            </div>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    )
}
